import { render, staticRenderFns } from "./blogItem.vue?vue&type=template&id=466ec9bc&scoped=true&lang=html&"
import script from "./blogItem.vue?vue&type=script&lang=js&"
export * from "./blogItem.vue?vue&type=script&lang=js&"
import style0 from "./blogItem.vue?vue&type=style&index=0&id=466ec9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466ec9bc",
  null
  
)

export default component.exports